import { PullQuote } from "design-system/components/blocks/pull-quote/pull-quote";
import { createContentfulComponent } from "frontend/contentful/lib/create-contentful-component";
import { PullQuoteEntry } from "frontend/contentful/schema/blocks";
import { RenderContentfulRichText } from "../utils/render-contentful-rich-text";
import { getPersonProps } from "../utils/get-person.props";

export const ContentfulPullQuote = createContentfulComponent<PullQuoteEntry>(
  ({ entry, createEditAttributes }) => {
    return (
      <PullQuote
        align={entry.fields.alignment}
        quote={<RenderContentfulRichText document={entry.fields.quoteText} />}
        attribution={getPersonProps(entry.fields.attribution)}
        theme={entry.fields.theme}
        hideQuoteMarks={entry.fields.hideQuoteMarks}
        editAttributes={{
          quote: createEditAttributes({ entry, fieldId: "quoteText" }),
          attribution: createEditAttributes({ entry, fieldId: "attribution" }),
        }}
      />
    );
  },
);
